import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
    getAssignUserReq,
    getTeamMatesReq,
    getTeamMatesResClear,
    setCurrentView,
    getFilterLp,
    getFilterLpClear
} from "../../redux/assignCourse/actions";
import { setCurrentFilterView } from "../../redux/reports/actions";
import { SessionKeys } from "../../utils/AppUtils";
import StaticUtils from "../../utils/StaticUtils";
import Select from 'react-select'
import { useTranslation } from "react-i18next";
const ChooseLp = (props) => {

    const {
        selectedLpList, setSelectedLpList,
        currentReportObj, parentId,
        parentName, isMobile, isOnboard, selectedBrokerageList
    } = props;
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const { courseId } = useParams();
    const lpSearchRes = useSelector(
        (state) => state.assignCourse.chooseLpPath
    );
    const assignedUserRes = useSelector(
        (state) => state.assignCourse.assignedUsers
    );
    const [searchInput, setSearchInput] = useState("");
    const [lpList, setLPList] = useState([]);
    const [selectedCount, setSelectedCount] = useState(0);
    const [assignedUsers, setAssignedUsers] = useState([]);
    const [errorMsg, setErrorMsg] = useState('');
    const [lpOptionList, setLPOptionList] = useState([])
    const [defaultValue, setDefaultValue] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // useEffect(() => {
    //     dispatch(getFilterLpClear());
    //     searchLP()
    // }, []);

    useEffect(() => {
        setSelectedLpList([])
        setLPOptionList([])
        searchLP()
        setIsLoading(true)
    }, [selectedBrokerageList])

    useEffect(() => {
        setSelectedCount(selectedLpList?.length);

        const newDefaultValue = selectedLpList.map((lp) => ({
            value: lp.id,
            label: lp.prgname,
                }));
            
                setDefaultValue(newDefaultValue);
    }, [selectedLpList]);

    useEffect(() => {
        if (searchInput !== undefined && searchInput.length > 2)
            searchLP();
        else setErrorMsg("");
    }, [searchInput]);

    const searchLP = () => {
        setIsLoading(true)
        dispatch(
            getFilterLp({
                module: "chooseLpPath",
                postData: {
                    token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    is_onboarding: isOnboard,
                    search: searchInput,
                    brokerage: selectedBrokerageList,
                },
            })
        );

    };



    useEffect(() => {
        // console.log("lpSearchRes: ", lpSearchRes);
        if (!_.isEmpty(lpSearchRes)) {
            if (lpSearchRes?.status === "success") {
                const lpList = lpSearchRes?.payload?.payload
                setLPList(lpList);
                setLPOptionList(_.map(lpList, (lp) => {
					return {
						value: lp.id,
						label: lp.prgname,
					}
				}))
                if (!_.isEmpty(searchInput) && searchInput?.length > 2 && lpList.length === 0) {
                    setErrorMsg(t("No result found for your search."));
                } else {
                    setErrorMsg("");
                }
            } else {
                setLPOptionList([])
            }
            setIsLoading(false)
        } else {
            setErrorMsg("");
            setLPList([]);
            setIsLoading(false)
        }
    }, [lpSearchRes]);




    const selectItem = (index) => {
        let tempArr = _.cloneDeep(lpList);
        let selectedTempArray = _.cloneDeep(selectedLpList);
        if (!StaticUtils.isContainObject(selectedTempArray, tempArr[index], 1)) {
            selectedTempArray.push(tempArr[index]);
        }
        setSelectedLpList(selectedTempArray);
        tempArr.splice(index, 1);
        setLPList(tempArr);
    };

    const removeItem = (index) => {
        let selectedTempArray = _.cloneDeep(selectedLpList);
        let tempArr = _.cloneDeep(lpList);
        if (!StaticUtils.isContainObject(tempArr, selectedTempArray[index], 1)) {
            tempArr.push(selectedTempArray[index]);
        }
        setLPList(tempArr);
        selectedTempArray?.splice(index, 1);
        setSelectedLpList(selectedTempArray);
    };

    return (
        <>
            <div className="chooseteamate">
                {isOnboard === 0 ? <h4>{t("Choose Action Paths")}</h4> : <h4>{t("Choose Onboarding")}</h4>}
                <div className="input-lear position-relative d-flex">
                    <label for="teamsearch" className="input__label">
                        {t("Search")}
                    </label>
                    {/* <input
                        type="text"
                        id="teamsearch"
                        name="teamsearch"
                        className="input_searchfield_search-cart "
                        placeholder="Start searching"
                        onChange={(evt) => {
                            setSearchInput(evt.target.value);
                        }}
                    /> */}
                    <Select 
							isMulti
							name="colors"
							className="basic-multi-select w-100 multi-label-select"
    						classNamePrefix="xsel"
							options={lpOptionList}
                            value={defaultValue}
                            isLoading={isLoading}
							onChange={(e) => {
								console.log(e)
								// setSelectedOffice(e)
								if (!_.isEmpty(e)) {
									setErrorMsg('')
									let data = [];
									for (let lp of lpList) {
										for (let sO of e) {
											if (sO.value === lp.id) {
												data.push(lp)
											}
										}
									}
									setSelectedLpList(data)
								} else {
									setSelectedLpList([])
									// setErrorMsg("Please select at lease one Action Path.");
								}
							}}
						/>
                </div>
                <p className="error-msg">{errorMsg}</p>
                {/* <div className="search-team-result">
                    {lpList?.map((item, index) => {
                        return (
                //             <div className="team-result-box">
                //                 {/*<div class="team-user-img">
                //   <img
                //     src={
                //       item?.profile_img !== ""
                //         ? item?.profile_img
                //         : "/images/avatar.svg"
                //     }
                //     alt="user"
                //   />
                //   </div>
                                <div className="userteamname">{item?.prgname
                                }</div>
                                <div
                                    className="addteammate cursor-pointer"
                                    onClick={() => {
                                        selectItem(index);
                                    }}
                                >
                                    +
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="teamselected">
                    {isOnboard===0 ?
                        <div className="selectresilt">
                            Selected Action Paths<strong>({selectedCount})</strong>
                        </div> : <div className="selectresilt">
                            Selected Onboarding<strong>({selectedCount})</strong>
                        </div>

                    }
                    <div className="search-team-result slectedteammates">
                        {selectedLpList?.map((item, index) => {
                            return (
                                <div className="team-result-box">
                    //                 {/*<div class="team-user-img">
                    // <img
                    //   src={
                    //     item?.profile_img !== ""
                    //       ? item?.profile_img
                    //       : "/images/avatar.svg"
                    //   }
                    //   alt="user"
                    // />
                    // </div>
                                    <div className="userteamname">{item?.prgname}</div>
                                    <div
                                        className="addteammate cursor-pointer"
                                        onClick={() => {
                                            //   console.log("removeItem");
                                            removeItem(index);
                                        }}
                                    >
                                        +
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div> */}



                {false && <div className="buttonsteammate">
                    <button
                        type="button"
                        className="btn btn-primary btn-block back-button"
                        onClick={() => {
                            dispatch(setCurrentFilterView(1));
                        }}
                    >
                        Back
                    </button>
                    {selectedCount > 0 ? (
                        <button
                            type="button"
                            className="btn btn-primary btn-block setup-button"
                            onClick={() => {
                                dispatch(setCurrentFilterView(1));
                            }}
                        >
                            Proceed
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="btn btn-primary btn-block setup-button"
                            disabled
                        >
                            Proceed
                        </button>
                    )}
                </div>}
            </div>
        </>
    );
};

export default ChooseLp;
